const CODE_TO_KEY = {
  FILE_TOO_LARGE: 'idpPage.errors.fileTooLarge',
  INVALID_EXPECTED_CLASSES_JSON: 'idpPage.errors.invalidExpectedClassesJson',
  INVALID_OPTIONS_JSON: 'idpPage.errors.invalidOptionsJson',
  INVALID_FORM_JSON: 'idpPage.errors.invalidFormJson',
  INVALID_REQUEST_BODY: 'idpPage.errors.invalidRequestBody',
  INVALID_FORM_METADATA: 'idpPage.errors.invalidFormMetadata',
  INTERNAL_ERROR: 'idpPage.errors.internalError',
};

/**
 * Maps API error JSON (`errors[0].code`) to a localized UI message, or null.
 * @param {string} responseBody
 * @param {(key: string) => string} t
 */
export function messageFromStructuredApiError(responseBody, t) {
  try {
    const j = JSON.parse(responseBody);
    const code = j.errors?.[0]?.code;
    const key = code ? CODE_TO_KEY[code] : null;
    if (key) {
      return t(key);
    }
  } catch {
    /* ignore */
  }
  return null;
}
